import React from 'react';
import { X } from 'lucide-react';
import notificationService from '../utils/notificationService';

const NotificationSettingsModal = ({ isOpen, onClose }) => {
  const [soundEnabled, setSoundEnabled] = React.useState(notificationService.isSoundEnabled());
  const [browserNotificationsEnabled, setBrowserNotificationsEnabled] = React.useState(
    notificationService.isBrowserNotificationsEnabled()
  );

  const handleSoundToggle = () => {
    const newValue = !soundEnabled;
    setSoundEnabled(newValue);
    if (newValue) {
      notificationService.enableSound();
    } else {
      notificationService.disableSound();
    }
  };

  const handleBrowserNotificationsToggle = () => {
    const newValue = !browserNotificationsEnabled;
    setBrowserNotificationsEnabled(newValue);
    if (newValue) {
      notificationService.enableBrowserNotifications();
    } else {
      notificationService.disableBrowserNotifications();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900">Ustawienia powiadomień</h3>
          <button
            onClick={onClose}
            className="p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        
        <div className="p-4 space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium text-gray-900">Dźwięk powiadomień</p>
              <p className="text-sm text-gray-500">Odtwarzaj dźwięk przy nowych wiadomościach</p>
            </div>
            <button
              onClick={handleSoundToggle}
              className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 ${
                soundEnabled ? 'bg-primary-500' : 'bg-gray-200'
              }`}
            >
              <span
                className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                  soundEnabled ? 'translate-x-5' : 'translate-x-0'
                }`}
              />
            </button>
          </div>

          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium text-gray-900">Powiadomienia przeglądarki</p>
              <p className="text-sm text-gray-500">Wyświetlaj powiadomienia gdy aplikacja jest w tle</p>
            </div>
            <button
              onClick={handleBrowserNotificationsToggle}
              className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 ${
                browserNotificationsEnabled ? 'bg-primary-500' : 'bg-gray-200'
              }`}
            >
              <span
                className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                  browserNotificationsEnabled ? 'translate-x-5' : 'translate-x-0'
                }`}
              />
            </button>
          </div>
        </div>

        <div className="p-4 border-t border-gray-200 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-primary-500 text-white rounded-md hover:bg-primary-600 transition-colors"
          >
            Zamknij
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationSettingsModal;
